// Web mock for @react-native-firebase/analytics
// Provides no-op implementations that maintain the same API

const analyticsInstance = {
  logEvent: async (_name: string, _params?: Record<string, any>) => {},
  logScreenView: async (_params: { screen_name: string; screen_class?: string }) => {},
  setUserId: async (_id: string | null) => {},
  setUserProperty: async (_name: string, _value: string | null) => {},
  setUserProperties: async (_properties: Record<string, string | null>) => {},
  resetAnalyticsData: async () => {},
  setAnalyticsCollectionEnabled: async (_enabled: boolean) => {},
  setSessionTimeoutDuration: async (_milliseconds: number) => {},
  getAppInstanceId: async () => null,
  setDefaultEventParameters: async (_params: Record<string, any>) => {},
};

export function getAnalytics() {
  return analyticsInstance;
}

export function logEvent(
  _analytics: any,
  _name: string,
  _params?: Record<string, any>
) {
  // No-op on web
}

export function logScreenView(
  _analytics: any,
  _params: { screen_name: string; screen_class?: string }
) {
  // No-op on web
}

export function setUserId(_analytics: any, _id: string | null) {}
export function setUserProperty(_analytics: any, _name: string, _value: string | null) {}
export function setUserProperties(_analytics: any, _properties: Record<string, string | null>) {}
export function setAnalyticsCollectionEnabled(_analytics: any, _enabled: boolean) {}
export function resetAnalyticsData(_analytics: any) {}

const analytics = () => analyticsInstance;
analytics.logEvent = logEvent;
analytics.logScreenView = logScreenView;

export default analytics;
